export const getUserData = ({ user }) => {
  const { Auth, ...rest } = user;
  return { Auth, user: rest };
};

export const getAuthState = ({ user }) => user.Auth;

export const getUserValue =
  (...values) =>
  ({ user }) => {
    const result = {};
    for (let key of values) {
      result[key] = user[key];
    }
    return result;
  };
